import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkEmoji from 'remark-emoji'
import { useSiteContent } from '../../hooks/useSiteContent'
import { extractSections } from '../../lib/markdownSections'

/**
 * The Guild Info sections an applicant agrees to, by heading. Everything
 * else on Guild Info - loot rules, DKP values, bidding, addons - stays behind
 * the login. Renaming one of these headings on Guild Info takes it off the
 * public page, so the list is shown to officers there.
 */
export const PUBLIC_RULE_HEADINGS = ['What we do', "What we don't do", 'Raid voice channel']

/**
 * The guild rules for applicants, read from Guild Info so officers keep one
 * copy of them.
 */
export function GuildRules() {
  const { content, loading } = useSiteContent('guild_info')
  if (loading || !content) return <p className="text-sm text-gray-500">Loading the rules…</p>

  const rules = extractSections(content.body_md, PUBLIC_RULE_HEADINGS)
  if (!rules) return null

  return (
    <div className="prose prose-invert prose-sm max-w-none prose-headings:text-gray-100 prose-h2:text-lg prose-h2:mt-6 prose-strong:text-gray-100 prose-a:text-blue-400">
      <Markdown remarkPlugins={[remarkGfm, remarkEmoji]}>{rules}</Markdown>
    </div>
  )
}
